export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('app:mounted', () => {
    document.body.classList.remove('hidden');
  });
});
